import React, { useState, useEffect } from 'react';
// import localStorageHelper from '../../../utils/localStorageHelper';
// import { enableBackgroundScroll, disableBackgroundScroll } from '../../../utils/helper';
import './ProductImagesList.scss';

export default function ProductImagesList({
  list,
  openCarouselModal,
  // android_active,
  // update360ZIndex,
  // dataLocale,
}) {
  // const [showTooltip, setShowToolTip] = useState(false);
  const [isScrollDown, setIsScrollDown] = useState(false);
  // const productPageVisited = localStorageHelper.getItem('productPageVisited');

  // const hideTooltip = () => {
  //   setShowToolTip(false);
  //   update360ZIndex('1');
  //   enableBackgroundScroll();
  //   document.body.style.overflow = 'auto';
  // };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (!isScrollDown && window.pageYOffset > 20) setIsScrollDown(true);
    });
  }, []);

  // useEffect(() => {
  //   if (Boolean(android_active) && android_active === 1 && productPageVisited === null) {
  //     setShowToolTip(true);
  //     disableBackgroundScroll();
  //     update360ZIndex('1002');
  //     setTimeout(() => {
  //       localStorageHelper.setItem('productPageVisited', true);
  //     }, 2000);
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     hideTooltip();
  //   }
  // }, [android_active, productPageVisited]);

  return (
    <div className="product-images-list">
      <ul className="list">
        {list.map((url, index) => {
          if ((!isScrollDown && index < 4) || isScrollDown)
            return (
              <li
                key={index}
                // className={`${
                //   index === 1 && Boolean(android_active) && android_active === 1 && showTooltip
                //     ? 'active-image'
                //     : ''
                // }`}
                style={{
                  background:
                    'url(//static.lenskart.com/media/desktop/img/loader-lk.gif) no-repeat center center',
                }}
              >
                <figure>
                  <img
                    alt={`product ${index}`}
                    aria-label={`product listing ${index}`}
                    src={url}
                    onClick={() => openCarouselModal(index)}
                  />
                </figure>
              </li>
            );
        })}
      </ul>
      {/* {Boolean(android_active) && android_active === 1 && showTooltip && (
        <div className="padding-10 pos-abs bora-8 display-flex justify-space-evenly align-items-center flex-direction-column bg-white load-tooltip">
          <h6 sty className="fs14 font-bold">
            {dataLocale.CHECK_PRODUCT_360}
          </h6>
          <button
            className="ok-btn padding-5 fs14 letter-spacing-1 bg-white text-topaz text-uppercase"
            onClick={() => hideTooltip()}
          >
            {dataLocale.OKAY}
          </button>
          <div className="pos-abs arrow" />
        </div>
      )} */}
      {/* {Boolean(android_active) && android_active === 1 && showTooltip && (
        <div className="dark"></div>
      )} */}
    </div>
  );
}
